import { axiosInstance } from "../utils/axios";

export const fetchMe = async () => axiosInstance.get("/me");
